/**
 * Formatting utilities for display.
 */

/**
 * Safely stringify JSON, handling circular references and invalid data.
 */
export const safeStringify = (value: unknown): string => {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return '[Unable to display - circular reference or invalid data]';
  }
};

/**
 * Safely format a date string, handling invalid dates.
 */
export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return 'Invalid date';
  return date.toLocaleString();
};
